export const BankDetails = [
  { label: "Bank", value: "Federal Bank" },
  { label: "Branch", value: "Nadakkavu West" },
  { label: "Account number", value: "13000200020381" },
  { label: "IFSC Code", value: "FDRL0001300" },
];

export const QRList = [
  "Net banking",
  "UPI transaction (GPay, Paytm, PhonePe, Amazon Pay, and BHIM UPI)",
  "Debit card and Credit card",
  "QR Code payment",
];
